module.exports = __webpack_public_path__ + "img/undercon.abb11a91.svg";